module.exports = __webpack_public_path__ + "94b816c8f7be616e00c6a48742d18831.pdf";